export var MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH = 24;
export var MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH = 320;
export var MEDIA_SINGLE_SNAP_GAP = 3;
export var MEDIA_SINGLE_HIGHLIGHT_GAP = 10;
export var MEDIA_SINGLE_HANDLE_MARGIN = 12;
export var MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN = 8;
export var MEDIA_SINGLE_GUTTER_SIZE = MEDIA_SINGLE_HANDLE_MARGIN * 2;
export var DEFAULT_IMAGE_WIDTH = 250;
export var DEFAULT_IMAGE_HEIGHT = 200;
export var MEDIA_SINGLE_RESIZE_THROTTLE_TIME = 100;
export var Layout = /*#__PURE__*/function (Layout) {
  Layout["FULL_WIDTH"] = "full-width";
  Layout["WIDE"] = "wide";
  Layout["CENTER"] = "center";
  Layout["ALIGN_START"] = "align-start";
  Layout["ALIGN_END"] = "align-end";
  Layout["WRAP_RIGHT"] = "wrap-right";
  Layout["WRAP_LEFT"] = "wrap-left";
  return Layout;
}({});
export var wrappedLayouts = ['wrap-left', 'wrap-right', 'align-end', 'align-start'];
export var DEFAULT_ROUNDING_INTERVAL = 0.5;
export var CAPTION_PLACEHOLDER_ID = 'caption-placeholder';